import { logger } from '_/lib/logger'

const SW_URL = '/sw.js'
const swConfig: RegistrationOptions = { scope: '/', updateViaCache: 'none' }

export type ServiceWorkerHandle = {
	readonly update: () => Promise<void>
}

export const registerServiceWorker = (onNeedRefresh: (handle: ServiceWorkerHandle) => void): void => {
	if (import.meta.env.DEV || !('serviceWorker' in navigator)) return

	const activate = (waiting: ServiceWorker) => {
		onNeedRefresh({
			update: async () => {
				// The worker calls skipWaiting on this message; reloading before it
				// activates would just serve the old shell again.
				waiting.postMessage({ type: 'SKIP_WAITING' })
				await new Promise<void>(resolve => {
					navigator.serviceWorker.addEventListener('controllerchange', () => resolve(), { once: true })
				})
				location.reload()
			},
		})
	}

	navigator.serviceWorker
		.register(SW_URL, swConfig)
		.then(registration => {
			if (registration.waiting) {
				activate(registration.waiting)
			}

			registration.addEventListener('updatefound', () => {
				const installing = registration.installing
				if (!installing) return

				installing.addEventListener('statechange', () => {
					// Without a controller this is the first install, which is already
					// the newest version: prompting there would be a reload to nowhere.
					if (installing.state === 'installed' && navigator.serviceWorker.controller) {
						activate(installing)
					}
				})
			})
		})
		.catch(error => {
			logger.error('Failed to register service worker', error)
		})
}
